module.exports = __webpack_public_path__ + "static/media/aceshades-2.67d54a13.png";